"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eSalesForceStage = exports.eSalesForceStatus = void 0;
const basePolicy_class_1 = __importDefault(require("./basePolicy.class"));
var eSalesForceStatus;
(function (eSalesForceStatus) {
    eSalesForceStatus["UNQUALIFIED"] = "Unqualified";
    eSalesForceStatus["CONTACT_REQUESTED"] = "Contact Requested";
    eSalesForceStatus["REJECTED"] = "Rejected";
    eSalesForceStatus["BIND_PENDING"] = "Bind Pending";
    eSalesForceStatus["UNDERWRITER_REVIEW"] = "Underwriter Review";
    eSalesForceStatus["NOT_ENOUGH_INFORMATION"] = "Not Enough Information";
    eSalesForceStatus["MANAGER_REFERRAL"] = "Manager Referral";
    eSalesForceStatus["APPROVED_REFERRAL"] = "Approved Referral";
    eSalesForceStatus["REJECTED_REFERRAL"] = "Rejected Referral";
    eSalesForceStatus["CAPACITY_REFERRAL"] = "Capacity Referral";
    eSalesForceStatus["DECLINED_BY_LOADSURE"] = "Declined by Loadsure";
    eSalesForceStatus["DECLINED_BY_CAPACITY"] = "Declined by Capacity";
    eSalesForceStatus["QUOTED"] = "Quoted";
    eSalesForceStatus["BOUND"] = "Bound";
    eSalesForceStatus["READY_TO_QUOTE"] = "Ready to Quote";
})(eSalesForceStatus = exports.eSalesForceStatus || (exports.eSalesForceStatus = {}));
var eSalesForceStage;
(function (eSalesForceStage) {
    eSalesForceStage["NEW"] = "New";
    eSalesForceStage["QUOTED"] = "Quoted";
    eSalesForceStage["CLOSED"] = "Closed";
    eSalesForceStage["UNDER_REVIEW"] = "Under Review";
    eSalesForceStage["REFERRAL"] = "Referral";
})(eSalesForceStage = exports.eSalesForceStage || (exports.eSalesForceStage = {}));
exports.default = basePolicy_class_1.default;
//# sourceMappingURL=index.js.map